import React from "react";
import { ModalStyled } from "../ui/ModalStyled";
import { Box, Button, Typography } from "@mui/material";
import { Formik } from "formik";
import { InputStyled } from "../ui/InputStyled";
import { emailSliceNewDataThunk } from "../../redux/slices/emailSlice";
import { authSliceLogoutThunk } from "../../redux/slices/authSlice";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

export const EmailsModalCreate = ({ show, onShow }) => {
  const dispatch = useDispatch();

  const history = useHistory();

  const handleOnSubmit = (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    dispatch(
      emailSliceNewDataThunk({
        ...values,
        email: values.email.toLowerCase(),
      })
    )
      .unwrap()
      .then(() => {
        resetForm();
        onShow(null);
      })
      .catch((err) => {
        if (err?.code === 401) {
          setTimeout(() => {
            dispatch(authSliceLogoutThunk()).finally(() => {
              history.replace("/");
            });
          }, 3000);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <ModalStyled show={show} onShow={onShow} title={"Crear Correo Electrónico"}>
      <Box
        sx={{
          width: "100%",
          maxWidth: 650,
          bgcolor: "background.terciary",
          boxShadow: 24,
          p: 4,
          pt: 3,
          borderRadius: 2,
          maxHeight: "90vh",
          overflowY: "auto",
        }}
        className="md-scroll"
      >
        <Typography textAlign={"center"}>
          Al realizar esta acción no podras revertirla.
        </Typography>
        <Formik
          initialValues={{
            email: "",
          }}
          onSubmit={handleOnSubmit}
        >
          {({ isSubmitting, handleSubmit }) => (
            <>
              <Box
                component={"form"}
                onSubmit={handleSubmit}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 2,
                  mt: 2,
                }}
              >
                <InputStyled
                  fullWidth
                  disabled={isSubmitting}
                  name="email"
                  label="Correo electrónico"
                  placeholder="ejemplo@fapro.app"
                  type="email"
                  inputProps={{
                    autoComplete: "off",
                    form: {
                      autoComplete: "off",
                    },
                  }}
                />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: 2,
                    width: "100%",
                    mt: 2,
                  }}
                >
                  <Button
                    disabled={isSubmitting}
                    color="error"
                    type="button"
                    onClick={() => onShow(null)}
                  >
                    Cancelar
                  </Button>
                  <Button
                    disabled={isSubmitting}
                    variant="contained"
                    color="primary"
                    type="submit"
                    onClick={handleSubmit}
                  >
                    Crear
                  </Button>
                </Box>
              </Box>
            </>
          )}
        </Formik>
      </Box>
    </ModalStyled>
  );
};
